import {
  TKwikUIStepperOrientation,
  VKwikUIStepperOrientation
} from "./stepper.definitions";

export const isValidKeyValue = (key: string, value: any): boolean => {
  const { isArray } = Array;
  const isBoolean = (x: boolean) => typeof x === "boolean";
  const isNumber = (x: number) => typeof x === "number";
  const isString = (x: string) => typeof x === "string";

  const methods = {
    activeItemIndex: isNumber,
    clickable: isBoolean,
    id: isString,
    orientation: (x: TKwikUIStepperOrientation) =>
      VKwikUIStepperOrientation.includes(x),
    steps: isArray
  };

  return methods[key] && methods[key](value);
};
